import Popover from "@components/ui/popover";
import { ScrollArea } from "@components/ui/scroll-area";
import { useAnalyticsStoreShallow } from "@pages/analytics/store";
import { IconFilter2, IconSearch } from "@tabler/icons-react";
import { memo, useState } from "react";
import { useDebounceValue } from "usehooks-ts";
import { FoldersGroup } from "./folders-group";
import { StoriesGroup } from "./stories-group";
import { UsersGroup } from "./users-group";
import { VersionsGroup } from "./versions-group";

export const MainDataSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounceValue(searchTerm, 250);
  const { setShowMobileMenu } = useAnalyticsStoreShallow((s) => ({
    setShowMobileMenu: s.setShowMobileMenu,
  }));

  return (
    <div className="tw-flex tw-items-center tw-gap-2 -2xl:tw-mb-6 -2xl:tw-w-full -2xl:tw-justify-end -2xl:tw-px-4">
      <div className="-sm:tw-grow">
        <div className="tw-relative tw-h-9 tw-px-3 tw-outline-1 tw-outline-blue-100 tw-w-64 tw-ml-4 -sm:tw-ml-0 tw-outline tw-rounded-lg tw-bg-white -2xl:tw-hidden -xl:tw-block -sm:tw-w-full">
          <IconSearch className="tw-size-4 tw-text-blue-500 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-left-3" />
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsOpen(e.target.value.length >= 3);
            }}
            onFocus={() => setIsOpen(searchTerm.length >= 3)}
            onBlur={() => setIsOpen(false)}
            className="tw-pl-6 tw-outline-none tw-w-full tw-h-full tw-rounded-t-lg tw-text-sm tw-font-normal tw-text-blue placeholder:tw-text-blue-500"
          />
        </div>
        <Popover open={isOpen} onOpenChange={() => {}} placement="bottom-end">
          <Popover.Trigger>
            <></>
          </Popover.Trigger>
          <Popover.Content>
            <PopoverContent
              searchTerm={debouncedSearchTerm}
              onClose={() => {
                setIsOpen(false);
                setSearchTerm("");
              }}
            />
          </Popover.Content>
        </Popover>
      </div>
      <button
        type="button"
        onClick={() => {
          setShowMobileMenu(true);
          document.body.style.overflow = "hidden";
        }}
        className="tw-hidden -xl:tw-flex tw-items-center tw-gap-1 tw-outline-1 tw-text-blue hover:tw-bg-blue-50 tw-transition-colors tw-text-sm tw-font-sans tw-font-medium tw-outline-blue-100 tw-outline tw-rounded-lg tw-bg-white tw-h-9 tw-px-3.5 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      >
        <IconFilter2 />
        Filters
      </button>
    </div>
  );
};

const PopoverContent = memo(
  ({ searchTerm, onClose }: { searchTerm: string; onClose: () => void }) => {
    return (
      <div className="tw-rounded-lg tw-outline tw-w-[296px] !tw-outline-1 !tw-outline-blue/5 tw-bg-white tw-shadow-md">
        <ScrollArea maxHeight={450}>
          <FoldersGroup searchTerm={searchTerm} onClose={onClose} />
          <StoriesGroup searchTerm={searchTerm} onClose={onClose} />
          <VersionsGroup searchTerm={searchTerm} onClose={onClose} />
          <UsersGroup searchTerm={searchTerm} onClose={onClose} />
        </ScrollArea>
      </div>
    );
  },
);
